import { createRouter, createWebHistory } from 'vue-router';
import DashboardService from '@/services/DashboardService';
import Dashboard from '@/components/dashboard/DashboardView.vue';
import DashboardServiceV3 from '@/services/DashboardServiceV3';
import DashboardServiceV4 from '@/services/DashboardServiceV4';
import CheckoutCancel from '@/components/billing/CheckoutCancel.vue';
import CheckoutSuccess from '@/components/billing/CheckoutSuccess.vue';
import CallPricing from '@/components/call_pricing/CallPricing.vue';
import NotSupported from '@/components/billing/NotSupported.vue';

const routes = [
  {
    path: '/',
    redirect: '/manage_billing',
  },
  {
    path: '/home',
    redirect: '/manage_billing',
  },
  {
    path: '/manage_billing',
    component: Dashboard,
    props: { main_page: 'manage_billing' },
  },
  {
    path: '/software_credits',
    component: Dashboard,
    props: { main_page: 'software_credits' },
  },
  {
    path: '/worker_activity',
    component: Dashboard,
    props: { main_page: 'worker_activity' },
  },
  {
    path: '/invoices',
    component: Dashboard,
    props: { main_page: 'invoices' },
  },
  {
    path: '/checkout/success',
    component: CheckoutSuccess,
    props: (route) => ({ sessionId: route.query.session_id }),
  },
  {
    path: '/checkout/cancel',
    component: CheckoutCancel,
    props: (route) => ({ sessionId: route.query.session_id }),
  },
  {
    path: '/know_your_billing',
    name: 'KnowYourBilling',
    component: () => import('@/components/billing/BillingFAQ.vue'),
    meta: {
      requiresAuth: false,
      isPublic: true,
    },
  },
  {
    path: '/call_pricing',
    name: 'CallPricing',
    component: () => import('@/components/call_pricing/CallPricing.vue'),
    meta: {
      requiresAuth: false,
      isPublic: true,
    },
  },
  {
    path: '/not_supported',
    name: 'NotSupported',
    component: NotSupported,
    meta: {
      requiresAuth: false,
      isPublic: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.isPublic) {
    next();
    return;
  }

  try {
    const workspaceId = localStorage.getItem('billing_workspace_id') || '';
    const user = await DashboardService.checkUser(workspaceId);
    const billingVersion = await DashboardService.getBillingVersion(workspaceId);
    const version = billingVersion?.version;

    if (user && version === 'v4') {
      await DashboardServiceV4.getOrCreateAccount();
      next();
    } else if (user && version === 'v3') {
      await DashboardServiceV3.getOrCreateBillingAccount();
      next();
    } else if (user && version === 'v2') {
      await DashboardService.getOrCreateAccount();
      next();
    } else {
      next('/not_supported');
    }
  } catch (error) {
    console.error('Authentication check failed:', error);
    next('/not_supported');
  }
});
export default router;
